<template>
  <el-dialog
    ref="dialog"
    v-dialog-drag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    :width="width"
    :before-close="handleClose"
    @open="openCallBack"
  >
    <el-form
      ref="dialogForm"
      :hide-required-asterisk="viewModel"
      :model="form"
      :rules="rules"
      label-width="80px"
      :disabled="viewModel"
    >
      <slot name="content" :form="form"></slot>
    </el-form>
    <span v-if="showFooter" slot="footer" class="dialog-footer">
      <slot name="footBtn" :form="form">
        <el-button @click="close">取 消</el-button>
        <el-button v-if="!viewModel" type="primary" @click="save"
          >保存</el-button
        >
      </slot>
    </span>
  </el-dialog>
</template>

<script>
import "./dialogDrag";
export default {
  name: "CommDialog",
  props: {
    dialogTitle: {
      type: String,
      required: true,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    dialogVisible: {
      type: Boolean,
      required: true,
    },
    width: {
      type: String,
      default: "40%",
    },
    dialogData: {
      type: Object,
      default: () => {
        return { action: "add" };
      },
    },
    initData: {
      type: Function,
      default: null,
    },
    saveData: {
      type: Function,
      default: null,
    },
    rules: {
      type: Object,
      default() {
        return [];
      },
    },
    addInitData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      visible: false,
      viewModel: false,
      form: {},
    };
  },
  created() {
    this.visible = this.dialogVisible;
  },
  methods: {
    handleClose(done) {
      this.close();
      done();
    },
    async openCallBack() {
      if (this.dialogData.action == "view") {
        this.viewModel = true;
      } else {
        this.viewModel = false;
      }
      if (this.dialogData.action != "add") {
        if (this.initData) {
          this.form = await this.initData(this.dialogData);
        }
      } else {
        this.form = Object.assign({}, this.addInitData);
      }
    },
    close() {
      this.visible = false;
      this.$emit("dialogVisibleChange", this.visible);
    },
    async save() {
      let isValid = false;
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          isValid = true;
        } else {
          return false;
        }
      });
      if (isValid) {
        if (this.saveData) {
          await this.saveData(this.form);
        }
        this.close();
        this.$emit("callBack", { result: true, message: "保存成功" });
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
